import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-publish',
  imports: [ButtonModule],
  templateUrl: './publish.html',
  styleUrl: './publish.scss',
})
export class Publish {
  httpClient = inject(HttpClient);

  publishing = false;
  published = false;
  error: string | null = null;

  publish() {
    this.publishing = true;
    this.error = null;

    this.httpClient.post(environment.baseUrl + 'api/publish', {}).subscribe({
      next: () => {
        this.published = true;
      },
      error: (err) => {
        this.error = err.message;
        this.publishing = false;
      },
      complete: () => {
        this.publishing = false;
      },
    });
  }
}
